import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {  Loader, Icon, Input, Form } from 'semantic-ui-react';
import { CSVLink } from 'react-csv';
import _ from 'lodash';
import moment from 'moment';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import { filteredSearch, finalSearchResults } from '../../actions';
import { SearchFilter, Price, Dots } from '../../components';
import './zalandoSearch.css';
import { isFarFetchUser } from '../../lib/util';


class ZalandoSearch extends Component {


  constructor(props) {
    super(props);
    const sortOptions = ['name', 'rating', 'environment', 'labour', 'animal', 'categories', 'price', 'segment'];
    if (isFarFetchUser()) {
      sortOptions.push('farfecth');
    }
    this.state = {
      search: '',
      brand: '',
      sortname: null,
      sortsku: null,
      sortcategories: null,
      sortscore: null,
      sortenvironment: null,
      sortlabour: null,
      sortanimal: null,
      filter: { filters: {}, sort: {} },
      sortOptions,
      filteredArr: [],
      renderFilteredArr: [],
      results: [],
      searchResults: [],
     
      searchApplied: false,
      filterApplied: false,
      showPages: 19,
    };
    this.handleSearch=this.handleSearch.bind(this);
    this.handleSort=this.handleSort.bind(this);
    this.handleSubmit=this.handleSubmit.bind(this);
    this.handleClear=this.handleClear.bind(this);
    this.handleChip=this.handleChip.bind(this);
    this.handleShowMore=this.handleShowMore.bind(this);
  }

  componentWillMount() {
    if(this.props.searchResults[0]) {
      this.setState({results: this.props.searchResults});
    } else {
      this.props.filteredSearch();
      this.setState({isLoading: true});
    }
  }


  componentWillReceiveProps(nextProps) {
    if(nextProps.zolando !== this.props.zolando) {
      if(!nextProps.zolando.brands) {
        this.setState({
          results: _.map(nextProps.zolando, val => {
            return {
              Id: val.id,
              Name: val.name,
              Website: val.website,
              Size: val.size ? val.size : '',
              'Overall Score': val.score,
              'Score Out Of 5': val.dots,
              Label: val.label,
              Environment: val.environment ? val.environment.label : '',
              Labour: val.labour ? val.labour.label : '',
              Animal: val.animal ? val.animal.label : '',
              Categories: val.categories ? val.categories : '',
              Sku: val.sku ? val.sku : '' ,
              Headquarters: val.headquarters ? val.headquarters : '',
              Segment: val.segment ? val.segment : '',
              Price: val.price ? val.price : '',
              Farfetch: val.farfetch ? val.farfetch : '',
            };
          }),
          isLoading: false,
        });
      } else {
        this.setState({
          results: _.map(nextProps.zolando.brands, val => {
            return {
              Id: val.id,
              Name: val.name,
              Website: val.website,
              Size: val.size ? val.size : '',
              'Overall Score': val.score,
              'Score Out Of 5': val.dots,
              Label: val.label,
              Environment: val.environment ? val.environment.label : '',
              Labour: val.labour ? val.labour.label : '',
              Animal: val.animal ? val.animal.label : '',
              Categories: val.categories ? val.categories : '',
              Sku: val.sku ? val.sku : '' ,
              Headquarters: val.headquarters ? val.headquarters : '',
              Segment: val.segment ? val.segment : '',
              Price: val.price ? val.price : '',
              Farfetch: val.farfetch ? val.farfetch : '',
              
            };
          }),
          isLoading: false,
        });
      }
    }
  }
  
  componentWillUnmount() {
    this.state.searchApplied ? this.props.finalSearchResults(this.state.searchResults) : this.props.finalSearchResults(this.state.results);
  }

  handleChip(event) {
    event.preventDefault();
    this.setState({filteredArr: this.state.filteredArr.filter(val => val !== event.target.value)});
  }

  handleSort(event) {
    event.preventDefault();
    this.state.sortOptions.map(opt => {
      if(event.target.name !== opt) {
        this.setState({[`sort${opt}`]: null});
      } return null;
    });
    if(!this.state[`sort${event.target.name}`]) {
      Promise.resolve(this.setState({isLoading: true, [`sort${event.target.name}`]: 'desc'}))
        .then(Object.assign(this.state.filter.sort, { key: event.target.name, order: 'desc' }))
        .then(this.props.filteredSearch(this.state.filter));
    } else if(this.state[`sort${event.target.name}`] === 'desc') {
      Promise.resolve(this.setState({isLoading: true, [`sort${event.target.name}`]: 'asc'}))
        .then(Object.assign(this.state.filter.sort, { key: event.target.name, order: 'asc' }))
        .then(this.props.filteredSearch(this.state.filter));
    } else {
      this.props.filteredSearch();
      this.setState({isLoading: true, [`sort${event.target.name}`]: null});
      Object.assign(this.state.filter.sort, { key: event.target.name, order: null });
    }
  }

  handleSearch(event, { value }) {
    event.preventDefault();
    let searchArr = [];
    Promise.resolve(
      this.state.results.map(brand => {
        if(brand.Name.toLowerCase().includes(value.toLowerCase())) {
          searchArr.push({
            Id: brand.Id,
            Name: brand.Name,
            Website: brand.Website,
            'Overall Score': brand['Overall Score'],
            Label: brand.Label,
            Environment: brand.Environment,
            Labour: brand.Labour,
            Animal: brand.Animal,
            Categories: brand.Categories,
            'Score Out Of 5': brand['Score Out Of 5'],
            Headquarters: brand.Headquarters,
            Sku: brand.Sku,
            Price: brand.Price
          });
        } return null;
      })
    ).then(this.setState({searchApplied: value.length >= 2 ? true : false, searchResults: value.length >= 2 ? searchArr : this.state.results}));
  }

  handleSubmit(filter) {
    const composedFilter = this.state.filter;
    composedFilter.filters = filter;
    this.setState({
      renderFilteredArr: this.state.filteredArr,
    });
    console.log("up to filter", composedFilter);
    this.props.filteredSearch(composedFilter);
  }

  handleClear(event) {
    this.setState({
      isLoading: true,
      filteredArr: [],
      renderFilteredArr: [],
    });
    this.props.filteredSearch();
  }

  capitalize(string) {
    return string[0].toUpperCase() + string.slice(1);
  }

  handleShowMore() {
    this.setState((state, props) => {
      return {
        showPages: this.state.showPages += 20,
      };
    });
  }

  checkNumber(n) {
    if(n % 2 === 0) {
      return 'even';
    } else {
      return 'odd';
    }
  }

  populateRender(brand, index, history) {
    console.log("history", history);
    return (
      <tr key={brand.Id} onClick={() => history.history.push(`/brandPage/${brand.Id}`)}>
        <td className="stacked">
          <p>{brand.Name}</p>
          <p>{brand.Headquarters}</p>
          <p name='brandWebsite' className='brand-name'>View Brand Details</p>
        </td>
        <td className="stacked">
          <Dots dots={brand['Score Out Of 5']} />
          {brand.Label}
        </td>
        <td className="stacked">
          <p>{brand.Environment}</p>
        </td>
        <td className="stacked">{brand.Labour}</td>
        <td className='stacked'>{brand.Animal}</td>
        <td className='stacked'>{brand.Categories}</td>
        <td><Price price={brand.Price}/></td>
        <td className='stacked'>{brand.Segment}</td>
        {isFarFetchUser() && <td className='stacked'>{brand.Farfetch}</td>}
      </tr>
    );
  }

  renderSortButtons() {
    return this.state.sortOptions.map((val) => {
      return (
        // TODO: at the moment they wanna hide this buttons, activate soon as requested.
        // <div key={val} className='sort'><button className={this.state[`sort${val}`] ? 'sort-active' : 'sort-inactive'} name={val} onClick={this.handleSort}>{val === 'rating' ? 'Overall Rating' : this.capitalize(val)} <Icon name={!this.state[`sort${val}`] || this.state[`sort${val }`] === 'desc' ? 'arrow down' : 'arrow up'} /></button></div>
        <th key={val} name={val} className='sort'> {val === 'rating' ? 'Overall Rating' : this.capitalize(val)} </th>
      );
    });
  }

  renderResults(history) {
    if(this.state.isLoading === true) {
      return (<Loader active inline='centered' />);
    } else if(this.state.searchApplied) {
      return _.map(this.state.searchResults, (brand, index) => {
        return this.populateRender(brand, index, history);
      });
    } else {
      return _.map(this.state.results, (brand, index)=> {
        if(this.state.results.indexOf(brand) <= this.state.showPages) {
          return this.populateRender(brand, index, history);
        }
      });
    }
  }

  // This is a patch based on the bad data binding from server to component. 
  // It is used to filter out fields that doesn´t need to be exported in CSV.
  // Using lodas _. because is used somehwere else in the app. 
  forExport(brands) {
    const omit = ["Id", "Sku"];
    if (!isFarFetchUser()) {
      omit.push("Farfetch");
    }
    return brands.map((brand) => _.omit(brand, omit));
  }

  render() {
    const state = this.state;
    const history = this.props;

    return (
      <MuiThemeProvider>
        <div className='zolando-container'>
          <div className='filter-search'>
            <SearchFilter
              onApply={ filter => this.handleSubmit(filter) }
              onClear={ () => this.handleClear() }
            />
            <div className='search-bar-container'>
              <div className='search-bar'>
                <Form.Field>
                  <Input
                    placeholder='Search Brands'
                    onChange={this.handleSearch}
                    icon='search'
                  />
                </Form.Field>
              </div>
            </div>
          </div>
          <div className='filtered-list'>
            <div className='excel'>
              <CSVLink
                data={state.searchResults.length > 0 ? this.forExport(state.searchResults) : this.forExport(state.results)}
                filename={`Brand Export ${moment(Date.now()).format('LLL')}.csv`}
              >
                <button>Export in CSV format
                  <Icon name='file excel outline' />
                </button>
              </CSVLink>
            </div>

            <table className="table table-striped flex-table">
              <thead>
                <tr>{this.renderSortButtons()}</tr>
              </thead>
              <tbody>
                {this.renderResults(history)}
              </tbody>
            </table>

            {state.searchApplied && state.searchResults.length <= 0 ? <p className='no-results'>No Results Found</p> : ''}
            {this.state.results.length <= state.showPages || state.searchApplied ? '' : <button onClick={this.handleShowMore}>Show More</button>}
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

function mapStateToProps(state) {
  return {
    searchResults: state.zalandoSearchResults,
    zolando: state.zolando,
    state,
  };
}


export default withRouter(connect(mapStateToProps, { filteredSearch, finalSearchResults })( ZalandoSearch ));




// WEBPACK FOOTER //
// ./src/pages/zalandoSearch/ZalandoSearch.js